"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var React = require("react");
var ChartWeb_1 = require("@okay/okaychart-legacy/dist/src/ChartWeb");
var mapStateToProps = function (state) {
    return (__assign({}, state.estate.charts.find(function (it) { return it.active; })));
};
var mapDispatchToProps = function (dispatch) { return ({
    onBarClick: function (xIndex, yIndex) { },
}); };
var estateChart = function (props) {
    var getColour = function (n, total) {
        if (total === 6) {
            return ['#c33306', '#fba200', '#d2d015', '#90c221', '#0680c3', '#c306b8'][n];
        }
        return "hsl(" + (Math.floor(100 / total * n) + 20) + ",90%,40%)";
    };
    var values = Array.from(Array(props.yValues.length)).map(function (_, i) { return ({
        color: getColour(i, props.yValues.length),
        label: props.yLabels[i],
        series: props.yValues[i],
    }); });
    var legends = values.map(function (it) { return ({
        color: it.color,
        text: it.label,
    }); });
    var IMAGE_MARGIN = 20;
    var CHART_LABEL_MARGIN = 140;
    var CHART_MARGIN = 40;
    var POINT_SIZE = 12;
    var LINE_DENSITY = 3;
    var FONT_SIZE = 26;
    var config = {
        margin: IMAGE_MARGIN,
        charts: [{
                values: values,
                legends: legends,
                type: 'stack',
                width: 1600,
                height: 600,
                cursorX: 0,
                backgroundColor: '#fff',
                xAxis: {
                    marginStart: CHART_LABEL_MARGIN,
                    marginEnd: CHART_MARGIN * 2,
                    fontSize: FONT_SIZE,
                    color: '#ccc',
                    legendColor: '#ccc',
                    label: props.xTitle,
                    series: props.xLabels,
                },
                yAxis: {
                    marginStart: CHART_MARGIN * (FONT_SIZE * 0.065),
                    marginEnd: CHART_MARGIN * (FONT_SIZE * 0.08),
                    valueSize: POINT_SIZE,
                    lineDensity: LINE_DENSITY - 1,
                    color: '#085963',
                    label: props.yTitle,
                    fontSize: FONT_SIZE,
                    zeroBased: true,
                },
            }],
    };
    return (React.createElement(ChartWeb_1.default, { config: config, onBarClick: props.onBarClick }));
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(estateChart);
